/* eslint-disable react/no-children-prop */
import React from 'react';
import { Spinner } from 'reactstrap';
import './styles.scss';

const WaitingScreen = () => (
  <div className="waiting-screen">
    <Spinner className="waiting-screen__spinner" children="" />
    <div className="waiting-screen__text">
      <div>Re-capturing...</div>
      <div>Please wait for a moment.</div>
    </div>
  </div>
);

export default WaitingScreen;
